import { DataTypeProvider } from '@devexpress/dx-react-grid';
import makeStyles from '@mui/styles/makeStyles';
import NRActorIcon from '../../../../NRIcons/NRActorIcon';
import NRAttackIcon from '../../../../NRIcons/NRAttackIcon';
import NRBotnetIcon from '../../../../NRIcons/NRBotnetIcon';
import NRExploitCodeIcon from '../../../../NRIcons/NRExploitCodeIcon';
import NRRansomwareIcon from '../../../../NRIcons/NRRansomwareIcon';
import ExploitsFormatterStyles from './ExploitsProvider.styles';
import customTheme from '../../../customTheme';
import { Tooltip } from '@mui/material';
import { CONSTANTS } from '../../../../constants/constants';
import { NRHandleEmptyCellValue } from '../../CellComponent/CellComponent';
import NRKevIcon from '../../../../NRIcons/NRKevIcon';
const useStyles = makeStyles(ExploitsFormatterStyles);

function IconValue({ icon, value, title }) {
  const classes = useStyles();

  return (
    <>
      {!!title && (
        <Tooltip title={title} placement={'top'}>
          <div className={classes.iconValueMainContainer}>
            {icon}
            <div className={classes.iconValueValue}>{value}</div>
          </div>
        </Tooltip>
      )}
      {!title && (
        <div className={classes.iconValueMainContainer}>
          {icon}
          <div className={classes.iconValueValue}>{value}</div>
        </div>
      )}
    </>
  );
}

function ExploitsFormatter({ value, column, row }) {
  const classes = useStyles();
  const iconColor = customTheme.palette.neutral[700];
  const { threatActor, knownAttacks, botnet, inTheWild, exploitCode, ransomware, inKnownExploitedVulnerabilities } = value || {};
  return (
    <>
      {value && (
        <div className={classes.exploitsContainer}>
          {!!threatActor && (
            <IconValue
              icon={<NRActorIcon width={'20'} height={'20'} color={iconColor} />}
              value={threatActor}
              title={CONSTANTS.TABLE.SBOM_TABLE.TOOLTIPS.THREAT_ACTOR}
            />
          )}
          {!!knownAttacks && (
            <IconValue
              icon={<NRAttackIcon width={'20'} height={'20'} color={iconColor} />}
              value={knownAttacks}
              title={CONSTANTS.TABLE.SBOM_TABLE.TOOLTIPS.KNOWN_ATTACKS}
            />
          )}
          {!!botnet && (
            <IconValue
              icon={<NRBotnetIcon width={'20'} height={'20'} color={iconColor} />}
              value={botnet}
              title={CONSTANTS.TABLE.SBOM_TABLE.TOOLTIPS.BOTNET}
            />
          )}
          {!!exploitCode && (
            <IconValue
              icon={<NRExploitCodeIcon width={'20'} height={'20'} color={iconColor} />}
              value={exploitCode}
              title={CONSTANTS.TABLE.SBOM_TABLE.TOOLTIPS.EXPLOIT}
            />
          )}
          {!!ransomware && (
            <IconValue
              icon={<NRRansomwareIcon width={'20'} height={'20'} color={iconColor} />}
              value={ransomware}
              title={CONSTANTS.TABLE.SBOM_TABLE.TOOLTIPS.RANSOMWARE}
            />
          )}
          {!!inKnownExploitedVulnerabilities && (
            <IconValue
              icon={<NRKevIcon width={'20'} height={'20'} color={iconColor} />}
              value={inKnownExploitedVulnerabilities}
              title={CONSTANTS.TABLE.SBOM_TABLE.TOOLTIPS.KEV}
            />
          )}
          {!threatActor && !knownAttacks && !botnet && !inTheWild && !exploitCode && !ransomware && <NRHandleEmptyCellValue />}
        </div>
      )}
    </>
  );
}
export const ExploitsProvider = props => <DataTypeProvider formatterComponent={ExploitsFormatter} {...props} />;
